<template>
  <div class="addressBg">
    <div class="addressHeader">

    </div>
      
      <div class="addressConfirm">
        <div class="buyPrice">
            <div class="van-cell van-hairline van-field">
              <div class="van-cell__title"><span>支付金额</span></div>
              <div class="van-cell__value"><div class="van-field__body"><span class="redColor">{{buyPrice|currency2}}</span><span class="coupon grayColor" v-show="showVoucher">(已减去{{voucherPrice|currency2}}预约款)</span></div></div>
            </div>
        </div>
      <van-address-edit
      :area-list="areaList"
      save-button-text="确认地址，去支付"
      @save="onSave"
      />
      </div>
   
  </div>
</template>

<script>
import Vue from 'vue';
import click_handler from "../tools/mgtv/click";
import { page_view, click_event } from "../tools/mgtv/analysis";
import { AddressEdit } from 'vant';
import { Toast } from 'vant';
import areaList from '../../node_modules/vant/packages/area/demo/area';
import {getCurrTime,getCouponList} from '../api/getData'
import orderAndPay from '../api/pay'
import {isIphone, isIpad, isWeiXin, isApp, isAndroid, isOTT, getInvoker, getPlatform,isSupportsWebP} from '../tools/mgtv/env'
import {productId_order,productId_go,order_begin,order_end,go_begin,go_end,productPrice_order,productPrice_go, OrderProduct, GoProduct} from '../constant/products'
import {mapState, mapActions} from 'vuex'
Vue.use(AddressEdit);
export default {
  data() {
    return {
      now:"",
      openid:"",
      // productId:"",      
      channel:"",
      address:"",
      phone:"",
      receiverName:"",
      voucherid:"",
      returnUrl:"",
      areaList,
      searchResult: []
    }
  },
  computed: {
        ...mapState([
            'actInfo',
            'userInfo',
            'deviceInfo',
            'urlParams',
            'ticket',
            'voucher',
            'product'
        ]),
        showVoucher(){
          return this.voucher.id?true:false
        },
        buyPrice:function(){
            let buyPrice = this.product.price
            if(this.voucher.id){
              buyPrice = this.product.price - this.voucher.amount/100
            }          
            console.log("getBuyPrice：",buyPrice)
            return buyPrice;
        },
        voucherPrice(){
          return this.voucher.amount?this.voucher.amount/100:0
        }
  },
  mounted () {
    history.pushState(null,null,`/usercenter/niunai.html`)
    page_view('地址确认页',this);
    console.log("AddressConfirm document.URL",document.URL)
    console.log("AddressConfirm this.urlParams",this.urlParams)
    this.initPage();
    
  }
  ,
  methods: {
    initPage(){
      console.log("this.product:",this.product)
      // if(this.voucher.id){
      //   Toast('代金券'+this.voucher.amount/100+'元')
      // }
    },
    pay_success(){
      this.$router.push({
        path: `/PaySuccess`,
        query: this.$route.query
      })
    },
    onSave(content) {
      click_handler(
        "地址确认页-去支付",
        () => {
          let order_params ={}
          order_params.productId = this.product.id
          order_params.ticket =  this.ticket     
          order_params.phone = content.tel 
          order_params.receiverName =  content.name       
          order_params.mac =  "qqq"          
          order_params.address= content.province+content.city+content.county+content.address_detail 
          order_params.voucherid =  this.voucher.id  
          console.log(order_params)
          let code = this.$route.query.code;
          orderAndPay(order_params,code,this.pay_success,this);
        },
        {
          need_login: true,
          need_act: true
        },
        this);
    },
    onClickLeft() {
      this.$router.pop();
    }
  }
}
</script>
<style lang="stylus">
.orderApp
  .addressConfirm
    font-size 0.3rem
    .van-button--primary
        background-color  #FD6A55
        border  1px solid #FD6A55
    .van-cell
      line-height 0.42rem
      padding 0.54rem 0.44rem 0.33rem 0.44rem
      font-size 0.3rem
    .van-address-edit__buttons
      padding 0.74rem 0.46rem
      .van-button--normal
          width 6.6rem
          height 0.9rem
          font-size 0.32rem
          border-radius 0.9rem
.goApp
  .addressBg
    width 100%
    min-height: 13.34rem;
    background-image: radial-gradient(51% 96%, #261E3F 44%, #110F17 97%);
  .addressHeader
    width 100%
    height 4.02rem
    background: url('../../static_niunai/img/addressBg.png') no-repeat;
    background-size: 100% 100%;

  .addressConfirm
    position relative
    font-size 0.3rem
    width 6.9rem
    background-color white 
    margin 0 auto
    border-radius 0.2rem
    div 
      font-size 0.3rem
    .buyPrice
      background transparent
      .coupon
        padding-left 0.5em
        font-size 0.26rem
    .van-address-edit
      background transparent
      .van-cell-group
        background transparent
    .van-cell
      background transparent
    .van-button--primary
      background-color  #FD6A55
      border  1px solid #FD6A55
    .van-cell
      line-height 0.42rem
      padding 0.54rem 0.44rem 0.33rem 0.44rem
      font-size 0.3rem
    .van-address-edit__buttons
      padding 0
      background transparent
      position relative
      top 1.2rem

      .van-button--normal
          display block
          margin 0 auto
          width 6.8rem
          height 0.9rem
          line-height 0.9rem
          background-image linear-gradient(-180deg, #FFEBA4 3%, #E0B580 100%)
          border-radius 1rem
          font-size 0.32rem
          color #0B0E1A
          border none
    .van-field 
      .van-cell__title
            max-width 1.6rem
  .redColor
    color #FD6A55
  .grayColor
    opacity 0.7

</style>
<style>
[class*=van-hairline]::after{
  border:none
}
</style>


// WEBPACK FOOTER //
// src/pages/AddressConfirm.vue